module.exports = __webpack_public_path__ + "static/img/kb-card-img-03-01@w.23f3797.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/kb-card/kb-card-img-03-01@w.jpg
// module id = dGR8
// module chunks = 0